/* eslint-disable */
import { I18N_LANG_EN_AU } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `PlaceOrderPage`;

i18nStore.add(I18N_LANG_EN_AU, key, {
  PageTitle: `Place An Order`,
});
